const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Login",
    dataIndex: "terminalID",
    sorter: (a, b) => a?.terminalID - b?.terminalID,
    render: defaultRender,
  },
  {
    title: "Platform",
    dataIndex: "platform",
    sorter: (a, b) => a?.platform?.localeCompare(b?.platform),
    render: defaultRender,
  },
  {
    title: "A/C Type",
    dataIndex: "planName",
    sorter: (a, b) => a?.planName?.localeCompare(b?.planName),
    render: defaultRender,
  },
  {
    title: "Balance",
    dataIndex: "balances",
    render: defaultRender,
  },
  {
    title: "User Name",
    dataIndex: "username",
    render: defaultRender,
  },
  {
    title: "Password",
    dataIndex: "tradingPassword",
    render: defaultRender,
  },
  {
    title: "Leverage",
    dataIndex: "leverage",
    sorter: (a, b) => a?.leverage - b?.leverage,
    render: defaultRender,
  },
  {
    title: "Currency",
    dataIndex: "currency",
    sorter: (a, b) => a?.currency?.localeCompare(b?.currency),
    render: defaultRender,
  },

  {
    title: "Created At",
    dataIndex: "createdAt",
    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  { title: "Action", dataIndex: "action", render: defaultRender },
];

export default columns;
